import React from 'react';

import ThaivivatLogo from '../components/ThaivivatLogo.js'




function InformUploadDocComponent(props) {

  let onSuccess = props.onSuccess
  let onFail = props.onFail
  let onCreateNewInform = props.onCreateNewInform

  function submit(  ){
    onSuccess()
  }
  
  return (
    <div className=' flex-wrap w-full '>

    <div className="flex-none md:hidden w-full bg-green-500 py-[11px] pl-4">
      <div className=''>
        <ThaivivatLogo></ThaivivatLogo>
      </div>
    </div>
    
    <div className='flex flex-wrap w-full justify-center '>
      <div className='flex-wrap w-full md:w-[428px] pt-10 px-4 md:px-11'>

        <div className='flex-wrap w-full'>
          <span className='flex w-full text-2xl md:text-[32px] not-italic leading-[44px]'>อัพโหลดเอกสารเพิ่มเติม</span>
          <span className='flex w-full mt-4 text-base font-normal not-italic leading-5 text-grey-600'>ทางสินไหมได้มีการตรวจสอบเอกสารของคุณ ซึ่งยังขาดหรือเอกสารผิดกรุณายื่นใหม่อีกครั้ง</span>
        </div>

        <div className='flex-wrap w-full mt-6 md:mt-10'>

          <div className='flex flex-wrap w-full '>
            <span className='w-full font-medium not-italic text-sm'>เลขรับแจ้ง</span>
            <div className=' flex-wrap w-full mt-1'>
              <input value={""} onChange={ (e)=> {   }} type={'search'} className={'w-full font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุ' />
            </div>  

          </div>
        

        </div>

        <div className='flex-wrap w-full mt-6 md:mt-[24px]'>

          <div className='flex flex-wrap w-full '>
            <span className='w-full font-medium not-italic text-sm'>รายการเลขที่</span>
            <div className=' flex-wrap w-full mt-1'>
              <input value={""} onChange={ (e)=> {   }} type={'search'} className={'w-full  font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400   ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ระบุ' />
            </div>  

          </div>
        

        </div>
        

        {/* <div className='w-full mt-6'>
          <span className='flex w-full text-xs text-red-500'>กรุณาเลือกทะเบียนรถ</span>
        </div> */}

        


        <div className='w-full mt-6'>
          <button 
              onClick={(e)=>{submit() }}
              className={'w-full lg:px-4 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-lg border-radius-other  '+ ( (false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                ต่อไป
          </button>
        </div>




        <div className='w-full mt-6 md:mt-10'>
          <span className='not-italic font-normal w-full text-base leading-5'>หากคุณไม่มีสามารถขอเลขรับแจ้งได้กับพนักงาน กรุณาติดต่อที่หมายเลข <span className='text-green-500'>1231 กด 4</span></span>
        </div>

        <div className='w-full mt-6 md:mt-10'>
          <span onClick={onCreateNewInform} className='cursor-pointer not-italic font-normal w-full text-base leading-5 text-green-500'>แจ้งเคลมรายการใหม่</span>
        </div>

      </div>
    </div>
    </div>
  )
}

export default InformUploadDocComponent;